var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JsonExcel',_vm._b({attrs:{"data":_vm.exportData}},'JsonExcel',[_vm.$props, _vm.$attrs],false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }